import React, { useState } from 'react';
import './addpost.css';
import FileBase from "react-file-base64";
import ReactQuill from "react-quill";
import "../../../node_modules/react-quill/dist/quill.snow.css";
import { useDispatch } from "react-redux";
import { createPost, updatePost } from "../../actions/posts";
import Navbar from '../Navbar/navbar';
import { NavLink, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import leftImage from '../../Media/img.jpg';

function Addpost({ currentId, setCurrentId, posts }) {
    const navigate = useNavigate();

    console.log("Curent Id", currentId)
    const [loading, setLoading] = useState(false)
    // const post = useSelector((state) => currentId ? state?.postReducer?.find((p) => p._id === currentId) : null)
    // console.log("POST", post)

    console.log('POSTS', posts)
    const filterPost = posts?.filter(post => {
        return post.id === currentId
    })

    const objectfilterPost = filterPost?.[0]

    console.log("ans", objectfilterPost?.topic)

    const [values, setValues] = useState({
        topic: objectfilterPost ? objectfilterPost?.topic : "",
        postername: objectfilterPost ? objectfilterPost?.postername : "",
        category: objectfilterPost ? objectfilterPost?.category : "",
        image: objectfilterPost ? objectfilterPost?.image : "",
        message: objectfilterPost ? objectfilterPost?.message : "",
    })

    // useEffect(() => {
    //     if (filterPost) setValues(filterPost)
    // }, [filterPost])

    const dispatch = useDispatch();
    const handleChange = (ev) => {
        console.log("TARGET", ev.target.value)
        console.log("TARGET33", ev.target.value.slice(-1))
        if (ev.target.name === "topic") {

            setValues({
                ...values,
                [ev.target.name]: ev.target.value.replace(/[^a-z0-9':,. ]/gi, ""),
            });
        } else {
            setValues({
                ...values,
                [ev.target.name]: ev.target.value,
            });
        }
        // above is to remove special character, let's see if mysql work with special character
        // setValues({
        //     ...values,
        //     [ev.target.name]: ev.target.value,
        // });
    };

    const checkTopicLast = (values.topic.slice(-1) === "," || values.topic.slice(-1) === "'" || values.topic.slice(-1) === ":" || values.topic.slice(-1) === ".") ?
        values.topic.slice(0, -1) : values.topic


    const handleQuillEdit = (value) => {
        setValues((prev) => {
            return {
                ...prev,
                message: value
            }
        })
    }

    const clear = () => {
        setCurrentId(null);
        setValues({
            topic: "",
            postername: "",
            category: "",
            image: "",
            message: "",
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = {
            topic: checkTopicLast,
            postername: values.postername,
            category: values.category,
            image: values.image,
            message: values.message,
        }
        console.log("PAYLOAD", payload)
        if (currentId) {
            dispatch(updatePost(currentId, payload, setLoading, navigate, clear, toast));
        } else {
            setLoading(true)
            dispatch(createPost(payload, setLoading, clear, toast))
        }

    }



    return (
        <div>
            <Navbar>
                <NavLink to="/posts" exact activeClassName="active" className="nav-link">Viewposts</NavLink>
            </Navbar>
            <div className="addPostContainer">
                <div className="left">
                    <img src={leftImage} alt="leftImage" />
                </div>
                <div className='form-section'>
                    <h4>{currentId ? "Editing Post" : "Add a New Post"}</h4>
                    <div className='add-form'>

                        <form onSubmit={handleSubmit}>
                            <div className='inputfield-div'>
                                <label htmlFor="name">Post topic</label>
                                <input type="text" name="topic" placeholder="Post topic ...." value={values.topic} required className='inputfield' onChange={handleChange} />
                            </div>
                            <div className='inputfield-div'>
                                <label htmlFor="name">Post Category</label>
                                <select id="category" name="category" className='inputfield' onChange={handleChange} value={values.category} required>
                                    <option value="">Select Category</option>
                                    <option value="health">Men's Wellness</option>
                                    <option value="life">Life</option>
                                    <option value="relationship">Relationship</option>
                                    <option value="finance">Finance</option>
                                    <option value="career">Career</option>
                                    <option value="Investment">Investment</option>
                                    <option value="religion">Religion</option>
                                    <option value="sex">Sex</option>

                                </select>
                            </div>
                            <div className='inputfield-div'>
                                <label htmlFor="name" style={{ paddingBottom: "10px" }}>Post Image</label>
                                {/* <input type="text" name="image" placeholder="Post image..."className='inputfield'   onChange={handleChange}/> */}
                                <FileBase
                                    type="file"
                                    multiple={false}
                                    onDone={({ base64 }) => setValues({ ...values, image: base64 })}
                                    onChange={values.image}

                                />
                            </div>

                            <div className='inputfield-div'>
                                <label htmlFor="name">Post message</label>
                                <ReactQuill
                                    required
                                    placeholder="Write message ..."
                                    modules={Addpost.modules}
                                    formats={Addpost.formats}
                                    onChange={handleQuillEdit}
                                    value={values.message}
                                    name="message"
                                    className='text-editor'
                                />
                            </div>

                            <div className='inputfield-div'>
                                <label htmlFor="name">Poster Name</label>
                                <input type="text" name="postername" placeholder="Poster name ..." value={values.postername} required className='inputfield' onChange={handleChange} />
                            </div>

                            {loading ?
                                <button type="submit" className='form-btn submitting' style={{ pointerEvents: 'none' }}>
                                    <div class="spinner-grow spinner-grow-sm" role="status"></div>
                                    <span>Submitting ...</span>
                                </button>
                                :
                                <button type="submit" className='form-btn'>Submit</button>
                            }
                            <button onClick={clear} className="form-btn clear">Clear</button>





                        </form>
                    </div>
                </div>

                <ToastContainer />
            </div>
        </div>
    )
}

Addpost.modules = {
    toolbar: [
        [{ header: "1" }, { header: "2" }, { header: [3, 4, 5, 6] }, { font: [] }],
        [{ size: [] }],
        ["bold", "italic", "blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["clean"],
        ["code-block"]
    ],
}

Addpost.formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "blockquote",
    "list",
    "bullet",
    "code-block",
    "header",
]
export default Addpost